<template>
  <div class="informationList">
    <m-loading :loading="homeLoading" />
    <van-list v-if="newsList.length>0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadArticle">
      <div v-slidein class="news-item" v-for="(item, i) in newsList" :key="i" @click="toNewsDetail(item)">
        <div class="img-area">
          <img v-setshow :src="item.img" alt="" />
        </div>
        <div class="news-content">
          <div class="news-tit">{{ item.title }}</div>
          <div class="author">
            {{ item.time }}
          </div>
        </div>
      </div>
    </van-list>
    <div class="nullData" v-else-if="!homeLoading">
      <img class="nullData_img" src="../../assets/images/mine/quesheng.png" alt="">
      <div class="nullData_tip">
        暂无资讯
      </div>
    </div>
  </div>
</template>
<script>
import {getPageArticle} from "@/utils/api/home";
export default {
  components: {
  },
  data() {
    return {
      homeLoading:true,
      // 是否加载活动所有数据
      loading:false,
      finished:false,
      newsList:[],
      page:0,
    }
  },
  async mounted() {
    this.onLoadArticle()
  },
  methods: {
    // 新闻list数据
    onLoadArticle() {
      this.loading = true;
      this.page++;
      getPageArticle({
        pageNo: this.page,
        includeExternalLink: localStorage.getItem("port") == "douyin" ? 0 : 1,
        pageSize: 10
      }).then((res) => {
        if (res.success) {
          let newsList = res.data.records.map((e) => {
            return {
              title: e.title,
              isExternalLink:e.isExternalLink,
              externalLinkUrl:e.externalLinkUrl,
              img: e.cover,
              content: e.contents,
              id: e.id,
              intro: e.subTitle,
              authorHead: e.addUserImg,
              time: e.addTime || e.updateTime,
              authorName: e.addUserName
            };
          });
          this.newsList.push(...newsList);
          if (this.page * 10 >= res.data.total) this.finished = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.finished = true;
        }
        this.homeLoading = false
      });
    },
    // 打开新闻详情
    toNewsDetail(item) {
      if(item.isExternalLink == 1){
        window.location.href = item.externalLinkUrl;
      }else{
        window.localStorage.setItem(
          "home_news_detail_infos",
          JSON.stringify(item)
        );
        this.$router.push("/home/newsdetail");
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.informationList{
  position: absolute;
  min-height: 100vh;
  background-color:#F8F8F9;
  width: 375px;
  padding: 0 20px;
  .nullData{
    margin-top: 30%;
    .nullData_img{
      width: 146px;
      height: 120px;
    }
    .nullData_tip{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #404046;
      line-height: 18px;
    }
  }
  .news-item {
    display: flex;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    padding:15px;
    margin-bottom: 15px;
    .news-item-content{
      display: flex;
    }
    .img-area {
      width: 120px;
      min-width: 120px;
      height: 79px;
      border-radius: 10px;
      border: 1px solid #f2f2f2;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .news-content {
      margin-left: 10px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .news-tit {
        max-width: 180px;
        text-align: left;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        color: #222222;
        overflow: hidden;      
        text-overflow: ellipsis;      
        display: -webkit-box; 
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical; 
        -moz-line-clamp: 2;
        -moz-box-orient: vertical;
      }
      .author {
        height: 24px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #999;
        margin-left: 3px;
        max-width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .van-list{
    padding-top: 10px;
  }
}
</style>